module.exports = __webpack_public_path__ + "img/achievement2.a017e86d.jpeg";